export const clearStoredData = () => {
  smartStorage.removeItem("billingAddress");
};
